import CONSTANTS from '@/constants'

const PLAN_CODES = Object.values(CONSTANTS.PLANS)
const { CERTIFICATION_BUNDLE } = CONSTANTS.CATALOG_TYPES

interface ClassifiableItem {
  merchant_id?: string
  catalog_type?: string
}

/**
 * True when the product is a certification-prep bundle, flagged by the API via
 * catalog_type. Works for newly launched bundles with no hardcoded merchant_id.
 */
export const isCertificationBundle = (item?: ClassifiableItem | null): boolean =>
  item?.catalog_type === CERTIFICATION_BUNDLE

/**
 * True when a cart/product item is a subscription plan: either a known base or
 * promo plan (the finite set in CONSTANTS.PLANS) OR a certification bundle
 * flagged by the API. This lets the purchase flow (selection, payload, Recurly)
 * treat a newly launched bundle as a plan without a checkout deploy.
 */
export const isSubscriptionPlan = (item?: ClassifiableItem | null): boolean => {
  if (!item) return false
  if (isCertificationBundle(item)) return true
  return !!item.merchant_id && PLAN_CODES.includes(item.merchant_id)
}
